// extracted by mini-css-extract-plugin
export default {"wrapper":"ClientPanel_wrapper__yKgiX","main_container":"ClientPanel_main_container__-HU0e"};